// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"537":"9bbef178","680":"4b1e8987","696":"d659df3c"}[chunkId] + ".chunk.js");